<span [satPopoverAnchor]="hint" (click)="hint.toggle()"><i class="fa fa-question-circle"
    aria-hidden="true"></i></span>

<sat-popover #hint horizontalAlign="after">
  <div class="tooltip-wrapper">
    <div *ngIf="powerSupplyType === 'hint'">
      Please Select the StandBy/Non-StandBy
    </div>
    <div *ngIf="powerSupplyType === 'StandBy'">
      <b>StandBy</b>
      <ul>
        <li>Should be selected for Power Supplies that have the capability of going into Standby during commercial
          outages</li>
        <li>Should also be selected for situations where a transponder is connected to the power supply, but for some
          reason is not powered up</li>
        <ul>
          <li>Tech or XOC Agent should use the Generate MAC Placeholder to generate a placeholder MAC Address into the
            PSNB</li>
          <li>The IP Address will default to “0.0.0.0”</li>
          <li>This will allow the Power Supply to be sent to Continuity, but will be in an offline state</li>
        </ul>
      </ul>
    </div>
    <div *ngIf="powerSupplyType === 'Non-StandBy (With Transponder)'">
      <b>Non-StandBy (With Transponder)</b>
      <ul>
        <li>Used for power supplies that do not have battery backup, such as, a power supply connected in the basement
          of an apartment building</li>
        <li>Under The Show Battery Section, select 0 Strings of 0</li>
      </ul>
    </div>
    <div *ngIf="powerSupplyType === 'Non-StandBy (No Transponder)'">
      <b>Non-StandBy (No Transponder)</b>
      <ul>
        <li>In a case where there is no transponder, the Generate MAC Placeholder should be used to generate a
          placeholder MAC Address into the PSNB</li>
        <ul>
          <li>The IP Address will default to “0.0.0.0”</li>
        </ul>
        <li>Does not get sent to Continuity and does not write to the transponder</li>
      </ul>
    </div>
    <div *ngIf="powerSupplyType === 'Built But Not In Service'">
      <b>Built But Not In Service</b>
      <ul>
        <li>Should be used in a situation where a PS is built and not yet powering the plant</li>
        <li>In a case where there is no transponder, the Generate MAC Placeholder should be used to generate a
          placeholder MAC Address into the PSNB</li>
        <li>When clicking the ‘Save Changes’ button, the Power Supply info will be stored in the PSNB, but will not be
          sent to Continuity</li>
        <li>Power Supply is not ready for monitoring</li>
        <li>Once the Power Supply is in-service, the tech will need to go back and Edit the Power supply in the Power
          Supply Notebook, and change the Category from ‘Built But Not in Service’ to ‘Standby’, for example</li>
        <li>Tech will also need to update the MAC and IP Addresses if not originally provided</li>
      </ul>
    </div>
    <div *ngIf="powerSupplyType === 'Standby - No Communication'">
      <b>Standby - No Communication</b>
      <ul>
        <li>Should only be used for Power Supplies that have the capability of going into Standby during commercial
          outages but do not have DOCSIS connectivity to be remotely monitored</li>
        <li>In a case where a transponder is present but not yet connected, the Generate MAC Placeholder should be used
          to generate a placeholder MAC Address into the PSNB</li>
        <li>When clicking “Save Changes” the Power Supply info will not be sent to Continuity</li>
      </ul>
    </div>
    <div *ngIf="powerSupplyType === 'Built In Generator'">
      <b>Built In Generator</b>
      <ul>
        <li>Should only be used for Power Nodes (supplies that connect directly to centralized generators)</li>
        <li>When clicking “Save Changes” the Power Supply info will be sent to Continuity</li>
      </ul>
    </div>
    <div *ngIf="powerSupplyType === 'INET – Government Networks (Non-StandBy)'">
      <b>INET – Government Networks (Non-StandBy)</b>
      <ul>
        <li>Power Supplies used for Local Access Networks that do not have battery backup</li>
        <li>When clicking “Save Changes” the Power Supply info will not be sent to Continuity</li>
      </ul>
    </div>
    <div *ngIf="powerSupplyType === 'INET – Government Networks (StandBy)'">
      <b>INET – Government Networks (StandBy)</b>
      <ul>
        <li>Power Supplies used for Local Access Networks that have battery backup</li>
        <li>When clicking “Save Changes” the Power Supply info will be sent to Continuity</li>
      </ul>
    </div>
    <div *ngIf="powerSupplyType === 'Unmonitored Transponder'">
      <b>Unmonitored Transponder</b>
      <ul>
        <li>Should be selected for Power Supplies that have the capability of going into Standby during commercial
          outages</li>
        <li>Should also be selected for situations where a transponder is connected to the power supply and online, but
          we do not have the Power Supply Location</li>
        <ul>
          <li>Tech or XOC Agent should enter the MAC Address into the PSNB</li>
          <li>Power Supply info will not be sent to Continuity</li>
        </ul>
      </ul>
    </div>
  </div>
</sat-popover>